const incidentSeverityOptions = [
  { label: "Minor", value: "Minor" },
  { label: "Major", value: "Major" },
  { label: "Critical", value: "Critical" }
];

export default incidentSeverityOptions;
